import React from 'react';
import { styled } from '@ff/ui';
import SkeletonLoader from '@ff/ui/Skeleton/SkeletonLoader';

export default function CopyLandingLoader() {
  return (
    <Container>
      <TextLoader>
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
        <SkeletonLoader variant="text" height={35} />
      </TextLoader>
    </Container>
  );
}

const Container = styled.Box(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  padding: '130px 36px 72px 36px',
  width: '100%',
  height: '100%',
  minHeight: '100vh',
  [theme.mediaQueries.minWidth('961px')]: {
    paddingTop: '180px',
  },
}));

const TextLoader = styled.Box(({ theme }) => ({
  width: '100%',
  [theme.mediaQueries.minWidth('961px')]: {
    width: '66.6%',
  },
}));
